import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./Gallery.css"; // External CSS for styling

const Gallery = () => {
  const [category, setCategory] = useState("All");
  const [images, setImages] = useState([]); // Array of objects containing both thumbnail and full-size image
  const [index, setIndex] = useState(-1);
  const [loading, setLoading] = useState(true); // Loading state

  // Function to import images and wait for them to load
  function importImages(r) {
    return r.keys().map((key) => ({ src: r(key) })); // Convert to [{ src: "image.jpg" }]
  }

  // Function to preload images
  const preloadImages = (imageUrls) => {
    return Promise.all(
      imageUrls.map((image) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = image.src;
          img.onload = () => resolve(image);
          img.onerror = (error) => {
          
            resolve(null); // Resolve with null to avoid breaking Promise.all
          };
        });
      })
    ).then((results) => results.filter((image) => image !== null)); // Filter out failed images
  };

  useEffect(() => {
    const loadImages = async () => {
      setLoading(true); // Start loading

      let imagesArray = [];

      if (category === "All") {
        const imagesRealSizeArray1 = importImages(
          require.context(
            "../../assets/RealEnglishImages/TheBilingualProject",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray1 = importImages(
          require.context(
            "../../assets/RealEnglishImages/TheBilingualProject/ThumbnailTheBilingualProject",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        const imagesRealSizeArray2 = importImages(
          require.context(
            "../../assets/RealEnglishImages/Facilities",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray2 = importImages(
          require.context(
            "../../assets/RealEnglishImages/Facilities/ThumbnailFacilities",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        const imagesRealSizeArray3 = importImages(
          require.context(
            "../../assets/RealEnglishImages/JuniorSenior",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray3 = importImages(
          require.context(
            "../../assets/RealEnglishImages/JuniorSenior/ThumbnailJuniorSenior",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        // Combine thumbnail and full-size images into a single array of objects
        imagesArray = [
          ...imagesThumbnailArray1.map((thumbnail, index) => ({
            thumbnail: thumbnail.src,
            fullSize: imagesRealSizeArray1[index].src,
          })),
          ...imagesThumbnailArray2.map((thumbnail, index) => ({
            thumbnail: thumbnail.src,
            fullSize: imagesRealSizeArray2[index].src,
          })),
          ...imagesThumbnailArray3.map((thumbnail, index) => ({
            thumbnail: thumbnail.src,
            fullSize: imagesRealSizeArray3[index].src,
          })),
        ];
      } else if (category === "TheBilingualProject") {
        const imagesRealSizeArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/TheBilingualProject",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/TheBilingualProject/ThumbnailTheBilingualProject",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        imagesArray = imagesThumbnailArray.map((thumbnail, index) => ({
          thumbnail: thumbnail.src,
          fullSize: imagesRealSizeArray[index].src,
        }));
      } else if (category === "Facilities") {
        const imagesRealSizeArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/Facilities",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/Facilities/ThumbnailFacilities",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        imagesArray = imagesThumbnailArray.map((thumbnail, index) => ({
          thumbnail: thumbnail.src,
          fullSize: imagesRealSizeArray[index].src,
        }));
      } else if (category === "JuniorSenior") {
        const imagesRealSizeArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/JuniorSenior",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );
        const imagesThumbnailArray = importImages(
          require.context(
            "../../assets/RealEnglishImages/JuniorSenior/ThumbnailJuniorSenior",
            false,
            /\.(png|jpeg|jpg)$/
          )
        );

        imagesArray = imagesThumbnailArray.map((thumbnail, index) => ({
          thumbnail: thumbnail.src,
          fullSize: imagesRealSizeArray[index].src,
        }));
      }

      // Preload images and wait for them to load
      try {
        await preloadImages(imagesArray);
        setImages(imagesArray);
      } catch (error) {
        console.error("Error loading images:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    loadImages();
  }, [category]);

  return (
    <section className="section" id="Gallery">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <ul className="list-inline categories-filter animation-nav" id="filter">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    onClick={() => setCategory("All")}
                    className={category === "All" ? "categories active" : "categories"}
                  >
                    All
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    onClick={() => setCategory("TheBilingualProject")}
                    className={category === "TheBilingualProject" ? "categories active" : "categories"}
                  >
                    The Bilingual Project
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    onClick={() => setCategory("Facilities")}
                    className={category === "Facilities" ? "categories active" : "categories"}
                  >
                    Facilities
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    onClick={() => setCategory("JuniorSenior")}
                    className={category === "JuniorSenior" ? "categories active" : "categories"}
                  >
                    Junior & Senior
                  </Link>
                </li>
              </ul>
            </div>
          </Col>

          {/* Loader */}
          {loading ? (
            <div className="text-center mt-5">
              <Spinner color="primary" /> Loading images...
            </div>
          ) : (
            <Row className="gallery-grid justify-content-center">
              {images.map((image, key) => (
                <Col xs={"auto"} key={key} className="gallery-item px-0">
                  <Card className="gallery-box">
                    <div className="gallery-container">
                      <Link className="image-popup" to="#" onClick={() => setIndex(key)}>
                        <img className="gallery-img" src={image.thumbnail} alt="" />
                      </Link>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Row>
      </Container>

      {/* Lightbox */}
      <Lightbox
        index={index}
        slides={images.map((image) => ({ src: image.fullSize }))}
        open={index >= 0}
        close={() => setIndex(-1)}
        render={{ buttonDownload: () => null }}
      />
    </section>
  );
};

export default Gallery;